import { render, staticRenderFns } from "./ExposedElectricalSheathDescription.vue?vue&type=template&id=4830c390&scoped=true"
import script from "./ExposedElectricalSheathDescription.vue?vue&type=script&lang=ts"
export * from "./ExposedElectricalSheathDescription.vue?vue&type=script&lang=ts"
import style0 from "./ExposedElectricalSheathDescription.vue?vue&type=style&index=0&id=4830c390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4830c390",
  null
  
)

export default component.exports